import { useState } from 'react'
import { noop } from 'lodash'
import { SelectInput } from '../../inputs'
import { resetSelectedSearchResult, useDispatch } from '@ggs/store'
import './SelectPager.scss'
import { useI18n } from '@ggs/i18n'

/**
 * @typedef {object} SelectPagerProps
 * @property {number} numPages
 * @property {number=} pageIndex
 * @property {number=} pageSize
 * @property {number=} count
 * @property {function=} onChange
 */

/**
 * @param {SelectPagerProps} props
 * @return {JSX.Element}
 */
const SelectPager = ({
  numPages = 0,
  pageIndex = 0,
  pageSize = 25,
  count = 1,
  onChange = noop,
}) => {
  const { t } = useI18n()
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(pageIndex)
  const pageOptions = [...Array(numPages)].map((_, i) => ({
    label: `${i * pageSize + 1} - ${Math.min((i + 1) * pageSize, count)}`,
    value: `${i}`,
  }))

  /**
   * @param {React.ChangeEvent<HTMLSelectElement>} e
   */
  const handleChange = (e) => {
    const page = parseInt(e.target.value)
    dispatch(resetSelectedSearchResult())
    setCurrentPage(page)
    onChange(page)
  }

  return (
    <SelectInput
      fullWidth={false}
      label={t('Showing: ')}
      id="search-map-pager"
      allowEmpty={false}
      selectOptions={pageOptions}
      inputFields={{
        onChange: handleChange,
        defaultValue: `${currentPage}`,
      }}
      formControlClasses={{
        root: 'select-pager',
      }}
      labelClasses={{
        root: 'select-pager__label',
      }}
      inputClasses={{
        root: 'select-pager__root',
        select: 'select-pager__select',
        icon: 'select-pager__icon',
      }}
      helperTextClasses={{
        root: 'select-pager__helper-text',
      }}
      listClasses={{
        root: 'select-pager-list',
      }}
      listItemClasses={{
        root: 'select-pager-list__item',
      }}
    />
  )
}

export default SelectPager
